import React, { Component } from 'react'

import ContentInfo from '../_ContentInfo'
import Display from '../../../../../v2SPRINTA/atoms/Display'
import Loading from '../../../../../SPRINTA/atoms/Loading'
import { FormGroup, Textarea } from '../../../../../v2SPRINTA/atoms/Form'
import Checktag from '../../../../../v2SPRINTA/atoms/Form/Checktag'
import { Col, Row } from '../../../../../v2SPRINTA/atoms/Grid'

import SprintaTips from '../../../../../SPRINTA/molecules/SprintaTips'
import { saveExperience, loadStructure } from '../../_utils'

import css from './style.css'

class Details extends Component {
    
    state = {
        tags: null,
    }

    constructor(props) {
        super(props)

        loadStructure()
        .then(resp => {
            this.setState({
                tags: resp.result
            })
        })
    }

    handleChange(target) {
        let experience = this.props.data.experience
        experience[target.name] = target.value
        
        this.props.setData({
            experience
        }, () => {
            if(['radio', 'select-one', 'checkbox'].indexOf(target.type) > -1)
            this.handleChanged(target)
        })
    }
    
    handleChanged(target) {
        this.validAndSaveField(target)
    }

    handleChangeArray(name, id, value) {
        var experience = this.props.data.experience
        var data = experience[name]
        
        if(value) {
            data.push(id)
        } else {
            var inx = data.indexOf(id)
            if(inx > -1)
                data.splice(inx, 1)
        }

        experience[name] = data
        this.props.setData({
            experience
        }, () => {
            this.validAndSaveField({ name })
        })
    } 

    validAndSaveField(target) {
        const { name } = target

        if(this.validateFields[name] && !this.validateFields[name]()) return;

        const form = {}
        if(name === 'bringWhat') {
            form['bringWhat'] = this.props.data.experience.bringWhat
        }

        if(name === 'structure') {
            this.props.data.experience.structure.forEach((s, k) => {
                if(s)
                form[`structure[${k}]`] = s
            })
        }

        let async = saveExperience(this.props.token, form)
        .then(resp => {})

        if(this.props.async) this.props.async(async)
    }

    validateFields = {
        // bringWhat: () => true
    }

    inStep() {
        let { bringWhat, structure } = this.props.data.experience
        return bringWhat || structure.length > 0 ? true  : false
    }

    render() {
        return (
            <ContentInfo
                title='O que os participantes ganharão e o que eles precisarão levar?'
                description='Defina o que você oferecerá de estrutura da sua experiência e o que os participantes precisam levar para que tudo ocorra bem.'
                steps={this.props.steps}>

                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Minha experiência oferecerá:
                            </Display>
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup>
                            {this.state.tags ? (
                                <ul className={css.listTags}>
                                    {this.state.tags.map((i, key) => (
                                        <li key={i.id}>
                                            <Checktag
                                                label={i.nameBr}
                                                onChange={e => this.handleChangeArray('structure', i.id, e.target.checked)}
                                                checked={this.props.data.experience.structure.indexOf(i.id) > -1 ? true : false}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <Loading />
                            )}
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                O que os participantes precisam levar?
                            </Display>
                        </FormGroup>

                        <FormGroup>
                            <SprintaTips>
                                Nem tudo estará incluso na experiência. Então informe os itens importantes para que os participantes levem e deixem a experiência ainda mais confortável para todos.
                            </SprintaTips>
                        </FormGroup>


                        <FormGroup>
                            <Textarea
                                label='Quais itens os participantes devem levar?'
                                maxLength={600}
                                name="bringWhat"
                                value={this.props.data.experience.bringWhat || ''}
                                maxLengthString="Você digitou {lenght} de {limit} caracteres"
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>
                
            </ContentInfo>
        )
    }

}

export default Details


// WEBPACK FOOTER //
// ./src/App/pages/CreateExperience/Steps/Details/index.js